import { IPetType, ISelectOption } from '../../types';
import { url, submitForm, safeJsonParse, createFetchOptions } from '../../util';

const toSelectOptions = (pettypes: IPetType[]): ISelectOption[] => pettypes.map(pettype => ({ value: pettype.id, name: pettype.name }));

export default (ownerId: string, petLoaderPromise: Promise<any>): Promise<any> => {
  return Promise.all(
    [fetch(url('/api/pettypes'), createFetchOptions())
      .then(response => safeJsonParse(response))
      .then(toSelectOptions),
    fetch(url('/api/owners/' + ownerId), createFetchOptions())
      .then(response => safeJsonParse(response)),
      petLoaderPromise,
    ]
  ).then(results => ({
    pettypes: results[0],
    owner: results[1],
    pet: results[2]
  }));
};
